module.exports = __webpack_public_path__ + "media/images/restaurant/areas/osaka-5f27d32ffa34d65b0750de4746c0c949.png";